import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

import { isInIframe, useEmbedMode } from "./embed-detection";

export function EmbedMeta() {
  const routerLocation = useLocation();
  const showcaseEmbedPreview = useEmbedMode();
  const shouldNoIndex = showcaseEmbedPreview || isInIframe();

  useEffect(() => {
    // Fill the iframe viewport so compact embed layouts can centre the widget card without
    // requiring width/height query overrides (those still control card sizing when present).
    if (isInIframe()) {
      document.documentElement.dataset.widgetIframeLayout = "fixed";
      return () => {
        delete document.documentElement.dataset.widgetIframeLayout;
      };
    }

    return undefined;
  }, [routerLocation.search]);

  useEffect(() => {
    if (shouldNoIndex) {
      const existingMeta = document.querySelector('meta[name="robots"]');

      if (existingMeta) {
        existingMeta.setAttribute("content", "noindex, nofollow, noarchive, nosnippet");
      } else {
        const metaTag = document.createElement("meta");
        metaTag.name = "robots";
        metaTag.content = "noindex, nofollow, noarchive, nosnippet";
        document.head.appendChild(metaTag);
      }

      return () => {
        const metaTag = document.querySelector('meta[name="robots"]');
        if (
          metaTag &&
          metaTag.getAttribute("content") === "noindex, nofollow, noarchive, nosnippet"
        ) {
          metaTag.remove();
        }
      };
    }
    return undefined;
  }, [shouldNoIndex, routerLocation.search]);

  return null;
}
